import { createSlice } from "@reduxjs/toolkit";
import { fetchCourseInstructors } from "./courseInstructor.thunk";

const initialState = {
  courseInstructors: [],
  loading: false,
  error: null,
};

const courseInstructorSlice = createSlice({
  name: "courseInstructor",

  initialState,

  reducers: {
    clearCourseInstructors: (state) => {
      state.courseInstructors = [];
    },
  },

  extraReducers: (builder) => {
    builder

      /* ============================================================
         FETCH COURSE INSTRUCTORS
      ============================================================ */

      .addCase(fetchCourseInstructors.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchCourseInstructors.fulfilled, (state, action) => {
        state.loading = false;
        state.courseInstructors =
          action.payload.data || [];
      })

      .addCase(fetchCourseInstructors.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  clearCourseInstructors,
} = courseInstructorSlice.actions;

export default courseInstructorSlice.reducer;